import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import EmptyStates from '../../../common/components/empty-states';
import withTranslate from '../../../common/hoc/with-translate';
import { requestLogin } from '../../../common/services/request-login';
import styles from './sign-up.scss';
import { getAllExperiments } from '../../../common/state/site/selectors';
import { State } from '../../../about/typings';
import { ComponentSettings } from '../../../app-settings/types/settings';
import { getComponentSettings } from '../../../common/selectors/settings-selectors';
import {
  LOGGED_OUT_CONSTANTS,
} from '../../../common/constants/empty-state';

interface SignUpProps {
  t: TranslationFunction;
  experiments: Record<string, 'true' | 'false'>;
  componentSettings: ComponentSettings;
}

const SignUp: React.FC<SignUpProps> = ({ t, componentSettings }) => (
  <EmptyStates
    title={t('sign-up.title')}
    content={t('sign-up.content')}
    titleFontClassName={LOGGED_OUT_CONSTANTS.title}
    descriptionFontClassName={LOGGED_OUT_CONSTANTS.description}
    titleTag={componentSettings.headingLevels?.loggedOutTitle ?? LOGGED_OUT_CONSTANTS.titleTag}
  >
    <button
      onClick={requestLogin}
      className={classNames(styles.signUpButton, 'ma-primary-button')}
      data-hook="loginButton"
    >
      {t('sign-up.action')}
    </button>
  </EmptyStates>
);

const mapStateToProps = (state: State) => ({
  experiments: getAllExperiments(state),
  componentSettings: getComponentSettings(state),
});

export default connect(mapStateToProps)(withTranslate(SignUp));
